import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { ChevronRight, Network } from 'lucide-react';
import styled from 'styled-components';

import { fetchMyTeamSummary } from '../../org-chart/orgChartApi';
import { Card, CardHeader, CardTitle } from '../styles';

// Ana pano — "Ekibinizde 2 Boş, 1 Ayrılan Pozisyon Var →" kartı. Kendi yüklemesini yapar
// (uç-başına GET deseni) ve YALNIZ kullanıcının alt dalında boş ya da sahibi ayrılan bir
// pozisyon varsa çizilir. Alt dalı olmayan kullanıcıda (çalışanların büyük çoğunluğu) kart
// HİÇ çizilmez — yer tutmaz, boş durum metni de göstermez.
//
// Yükleme hatasında da çizilmez: bu bir uyarı kartıdır, bilgisi yokken "sorun yok" DEMEZ
// (sayılar hiç gösterilmez); ayrıntılı "yüklenemedi" ayrımı /org-chart sayfasındadır.

const Row = styled.button`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 0;
  border: none;
  background: transparent;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
`;

const IconCircle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: linear-gradient(135deg, #F59E0B, #FBBF24);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
`;

const Text = styled.div`
  flex: 1;
  min-width: 0;
  font-size: 14px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  line-height: 1.4;
`;

const Sub = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: ${({ theme }) => theme.colors.text.dark?.medium || '#6B7280'};
  margin-top: 2px;
`;

const Arrow = styled.span`
  display: flex;
  color: ${({ theme }) => theme.colors.primary.main};
`;

export function teamVacancyMessageKey(vacant, leaving) {
  if (vacant > 0 && leaving > 0) return 'dashboard.teamVacancy.both';
  if (vacant > 0) return 'dashboard.teamVacancy.vacantOnly';
  return 'dashboard.teamVacancy.leavingOnly';
}

export default function TeamVacancyCard() {
  const { t } = useTranslation();
  const history = useHistory();
  const [summary, setSummary] = useState(null);

  useEffect(() => {
    let alive = true;
    fetchMyTeamSummary().then((result) => {
      if (!alive || result.state !== 'ok') return;
      setSummary(result.data || null);
    });
    return () => { alive = false; };
  }, []);

  if (!summary || !(summary.managedCount > 0)) return null;
  const vacant = summary.vacantCount || 0;
  const leaving = summary.leavingCount || 0;
  if (vacant <= 0 && leaving <= 0) return null;

  const openRequisitions = summary.openRequisitionCount || 0;

  return (
    <Card $delay="0.1s" data-testid="team-vacancy-card">
      <CardHeader>
        <CardTitle>{t('dashboard.teamVacancy.title')}</CardTitle>
      </CardHeader>
      <Row type="button" data-testid="team-vacancy-link" onClick={() => history.push('/org-chart?focus=me')}>
        <IconCircle><Network size={18} /></IconCircle>
        <Text>
          {t(teamVacancyMessageKey(vacant, leaving), { vacant, leaving })}
          {openRequisitions > 0 && (
            <Sub>{t('dashboard.teamVacancy.openRequisitions', { count: openRequisitions })}</Sub>
          )}
        </Text>
        <Arrow><ChevronRight size={18} /></Arrow>
      </Row>
    </Card>
  );
}
